<template>
  <a class="option-wrap main w-inline-block pointer" @click="signUp">
    <div class="option-top option-top-v">
      <div class="fixtender-logo w-embed">
        <img src="/images/fixtender.svg" class="auth-layout-logo" alt="Fixtender" />
      </div>
      <div class="option-info">
        <div class="big">
          <strong>{{ $t('Sign up to submit offer and ask questions') }}</strong>
        </div>
        <div class="text-secondary">
          {{ $t('Communicate with your Customer online') }}
        </div>
      </div>
      <div class="option-top__btn-wrapper">
        <Button size="small" class="option-top__btn desktop-show" @click.native.stop="signUp">
          {{ $t('Sign in') }}
        </Button>
        <Button class="option-top__btn mobile-show" @click.native.stop="signUp">
          {{ $t('Sign in') }}
        </Button>
      </div>
    </div>
  </a>
</template>

<script>
  import Button from '@/components/ui/Button';
  import { mapState } from 'vuex';

  export default {
    name: 'FixtenderSignUpOfPublicTender',
    components: {
      Button,
    },
    computed: {
      ...mapState('publicTender', ['tenderHash']),
    },
    methods: {
      async signUp() {
        await this.$router.push({
          name: 'login',
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
